import React from "react";
import { Crown } from "lucide-react";

export function PremiumBadge({ className = "", size = "sm" }) {
  const s = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2.5 py-1 text-xs";
  return (
    <span title="Paid membership badge" className={`inline-flex items-center gap-1 rounded-full bg-gradient-to-r from-amber-500 to-yellow-400 text-white font-bold shadow ${s} ${className}`} data-testid="premium-badge">
      <Crown className="w-3.5 h-3.5" /> OyeBest Premium
    </span>
  );
}
